export default __webpack_public_path__ + "static/media/administrator-white.09199ae3.svg";